<template>
  <div>
    <div class="title-icon">
      <img src="../../assets/img/icon.png" alt />
    </div>
    <div>
      <h3 style="font-size:23px;">註冊成功</h3>
    </div>
    <div class="detail">
      <p>您已成為優盾商戶，請盡快登錄優盾控製臺開啟您的優盾錢包專屬守護吧！</p>
    </div>
    <div class="bottom">
      <Button type="success" @click="copyLink">復製控製臺鏈接</Button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    copyLink() {
      this.copy('https://home.udun.io/')
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {}
}
</script>
<style scoped>
@media screen and (min-width: 768px) {
  .bottom {
    width: 30%;
    margin: 0 auto;
    margin-top: 80px;
    border-radius: 5px;
  }
  .bottom button {
    width: 100%;
    height: 40px;
    font-size: 18px;
    border-radius: 10px;
  }
  .title-icon img {
    width: 80px;
    height: 80px;
    margin-top: 80px;
    margin-bottom: 1.4rem;
  }
}
@media screen and (max-width: 768px) {
  .bottom {
    margin-top: 20rem;
    padding: 0 2rem;
  }
  .bottom button {
    width: 100%;
    height: 4rem;
    font-size: 18px;
    border-radius: 5px;
  }
  .title-icon img {
    width: 6rem;
    height: 6rem;
    margin-top: 8.4rem;
    margin-bottom: 1.4rem;
  }
}

.detail p {
  margin-top: 10px;
  font-size: 15px;
  padding: 0 20px;
}
</style>
